import { useEffect } from 'react';

import { useMyTaskFrameStateQuery } from '@/hook';
import { useTaskFrameStore } from '@/store';
import type { FrameStateStatistic, Task } from '@/type';

const getInitCount = (): FrameStateStatistic => ({
  done: 0,
  prework: 0,
  reject: 0,
  review: 0,
  reviewing: 0,
  working: 0,
  viewonly: 0,
  total: 0,
});

const useFrameCount = ({
  projectID,
  taskID,
}: {
  projectID: Task['projectID'];
  taskID: Task['id'];
}) => {
  const { setFrameCount } = useTaskFrameStore();
  const myFrameCountResult = useMyTaskFrameStateQuery(projectID, taskID);
  const myFrameCount =
    (myFrameCountResult.data as FrameStateStatistic) ?? getInitCount();

  useEffect(() => {
    setFrameCount({
      completed: myFrameCount.done,
      rejected: myFrameCount.reject,
      submitted: myFrameCount.review + myFrameCount.reviewing,
      total: myFrameCount.total,
    });
  }, [JSON.stringify(myFrameCount)]);
};

export default useFrameCount;
